export default __webpack_public_path__ + "static/pillars-transportation-c9403968b77fd218541ec05ad582b7a0.png";